import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { inject } from '@vercel/analytics'

Vue.config.productionTip = false
inject()

Vue.filter('round', (value, size = 2) => value.toFixed(size))

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
